import { useOrg } from '../use-org';

interface LegionV3OrgInfo {
	orgId?: string;
	isOrgLoading: boolean;
}

export function useV3OrgIdStatus(): LegionV3OrgInfo {
	const [{ orgId }] = useOrg();

	return {
		orgId,
		isOrgLoading: !orgId,
	};
}
